import React from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Loader } from '../..';
import styles from './LoadingMask.css';
var cx = classnames.bind(styles);
var LOADER = React.createElement(Loader, {
  size: "sm"
});

function LoadingMask(_ref) {
  var isLoading = _ref.isLoading,
      children = _ref.children,
      message = _ref.message,
      loader = _ref.loader,
      className = _ref.className;
  return React.createElement("div", {
    className: cx('masked', className)
  }, isLoading && React.createElement("div", {
    className: cx('mask')
  }, loader, message), children);
}

LoadingMask.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node.isRequired,
  loader: PropTypes.node,
  className: PropTypes.string,
  message: PropTypes.node
};
LoadingMask.defaultProps = {
  isLoading: false,
  className: '',
  message: false,
  loader: LOADER
};
export default React.memo(LoadingMask);